export const ROUTE_PAGE_API = '/gt_bus/api/v1/route_seo_data/'
export const VOYAGER_SEARCH_URL = '/api/v1/bus_node_search/find_node_by_name/?params='
export const OPERATOR_PAGE_API = '/gt_bus/api/v1/operator_seo_data/'
export const CITY_PAGE_API = '/gt_bus/api/v1/city_seo_data/?city='
export const ROUTE_CATEGORY_PAGE_API = '/gt_bus/api/v1/route_category_seo_data/'
export const ROUTE_OPERATOR_PAGE_API = '/gt_bus/api/v1/route_operator_seo_data/'
export const ROUTE_OPERATOR_TYPE_PAGE_API = '/gt_bus/api/v1/route_operator_category_seo_data/'
export const CITY_CATEGORY_PAGE_API = '/gt_bus/api/v1/city_category_seo_data/?city='
export const BUS_TYPE_PAGE_API = '/gt_bus/api/v1/rtc_bus_service/'
export const OPERATOR_DIR_PAGE_API = '/gt_bus/directory/operator/?limit=500&page='
export const SECTOR_DIR_PAGE_API = '/gt_bus/directory/sector/?limit=500&page='
export const CITY_DIR_PAGE_API = '/gt_bus/directory/city/?limit=500&page='
export const CATEGORY_PAGE_API = '/gt_bus/api/v1/category_seo_data/?slug='
export const STAND_PAGE_API = '/gt_bus/api/v1/city_bus_stand/?slug='
